manageAdmins.$inject = ['graph', 'adminApi']

export default function manageAdmins(graph, adminApi) {
  return {
    restrict: 'EA',
    template: require('./_manageAdmins.html'),
    scope: {
      entity: '=',
      entityType: '@type',
      admins: '=',
      users: '=', // used for typeahead autocomplete when adding admins
      adminsChanged: '&onAdminsChanged'
    },
    link: function(scope, elm) {
      // error handling
      scope.errorMessage = ''
      scope.showError = false
      function showErrorAlert(message, title) {
        scope.errorTitle = title
        scope.errorMessage = message
        scope.showError = true
      }

      scope.loading = false

      scope.$watchCollection('admins', function(newAdmins) {
        if (newAdmins && newAdmins.length) {
          scope.fetchAdminDataRoles()
        }
      })

      function refresh() {
        if (scope.entity && scope.entityType) {
          scope.errorMessage = ''
          scope.showError = false
          scope.loading = true
          graph.getAdmins(scope.entity.uuid, scope.entityType).then(
            function(admins) {
              scope.admins = admins
              scope.loading = false
              scope.adminsChanged({})
              scope.fetchAdminDataRoles()
            },
            function(reason) {
              showErrorAlert(reason, 'Error getting admins')
              scope.loading = false
            }
          )
        }
      }

      // scope.$watchCollection('entity', function() {
      //   refresh();
      // });
      // scope.$watch('entityType', function() {
      //   refresh();
      // });

      scope.removeAdminship = function(i) {
        var user = scope.admins[i]
        if (confirm('Are you sure you want to remove ' + user.email + ' as an admin?')) {
          console.log('Removing adminship for ' + user.email)
          graph.updateAdminship(scope.entity.uuid, scope.entityType, user.uuid, false).then(
            function(data) {
              if (data) {
                refresh()
              } else {
                showErrorAlert(data)
              }
            },
            function(reason) {
              showErrorAlert(reason)
            }
          )
        }
      }

      scope.fetchAdminDataRoles = function() {
        (scope.admins || []).forEach(function(da) {
          adminApi.getUserInfo(null, da.uuid).then(function(userInfo) {
            da._account = userInfo.user_account || {}
            da.admin_data_role = da._account.admin_data_role || ''
          })
        })
      }

      scope.editingDataRole = {}

      scope.toggleEditDataRole = function(index) {
        scope.editingDataRole[index] = !scope.editingDataRole[index]
      }

      scope.updateAdminDataRole = function(index) {
        const da = scope.admins[index]
        da._account = da._account || {}
        da._account.admin_data_role = da.admin_data_role || ''
        adminApi.editAccount(da.uuid, da._account).then(
          function() {
            scope.editingDataRole[index] = false
          },
          function(error) {
            showErrorAlert(error, 'Error updating admin data role')
          }
        )
      }

      scope.addAdminship = function(user) {
        console.log('Adding adminship for ' + user.email)
        // check that user is not already added
        if (
          scope.admins.filter(function(item) {
            return item.uuid === user.uuid
          }).length > 0
        ) {
          showErrorAlert(user.email + ' is already an admin.')
          return
        }
        graph.updateAdminship(scope.entity.uuid, scope.entityType, user.uuid, true).then(
          function(data) {
            if (data) {
              refresh()
              user = null
            } else {
              showErrorAlert(data)
            }
          },
          function(reason) {
            showErrorAlert(reason)
          }
        )
      }
    }
  }
}
